module.exports = __webpack_public_path__ + "img/nuclei-05.c308f8a5.png";